import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomTable } from 'src/app/models/custom-table-model';
import { EndpointRelation } from 'src/app/models/endpoint-relation-model';
import { DefaultService } from 'src/app/services/default/default.service';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-endpoint-relation',
  templateUrl: './endpoint-relation.component.html',
  styleUrls: ['./endpoint-relation.component.scss']
})
export class EndpointRelationComponent implements OnInit {

  @Input() endpoint_relation: EndpointRelation;

  inputs: Array<any> = [];
  form!: FormGroup;
  submitted: boolean = false;
  title: string = "";
  loading: boolean = true;
  file!: File;

  constructor(private location: Location, private formBuilder: FormBuilder, private spinner: NgxSpinnerService, private defaultService: DefaultService) { }

  get form_controls() { return this.form.controls; }

  ngOnInit(): void {

    this.generate_form();
  }

  generate_form() {

    if (this.endpoint_relation.name != null && this.endpoint_relation.id != null) {
      this.defaultService.get_one(this.endpoint_relation.name, this.endpoint_relation.id.toString()).subscribe((res: any) => {
        let data: any = {};
        if (res.data) {
          let customTable = new CustomTable(this.endpoint_relation.name);
          data = customTable.get_array_data([res.data])[0];
        } else {
          data = res;
        }

        if (this.endpoint_relation.name == "questions") {
          //let objFormBuilder = {};
          //objFormBuilder["idChapter"] = [data.idChapter, Validators.required];
          //this.form = this.formBuilder.group(objFormBuilder);
        }

        this.form.patchValue(data);
      }).add(() => {
        this.loading = false;
      });
    }


  }

  onSubmit() {
    if (this.endpoint_relation.name == "videos") {


    }
  }

  success_submit() {
    Swal.fire('Félicitation', 'Edit effectué avec succés', 'success');
    this.form.reset();
    this.location.back();
  }

  setBorderInput(item: any) {
    let styles = {
      "border": (this.form_controls[item].errors && this.submitted) ? "1px solid red" : "0px solid white"
    };
    return styles;
  }

  uploadInputsFile(name: string, event: any) {
    if (this.endpoint_relation.name == "videos") {
      this.file = event.target.files[0];
      let fileName = this.file.name.substring(0, this.file.name.lastIndexOf('.'));
      this.form.patchValue({ type: "player", link: this.endpoint_relation.link + "/" + fileName + "/" + "chapter.mp4" });
    }
  }

  onSelectChange(field_name: string, $event) {
    if (this.endpoint_relation.name == "videos") {
      this.file = null;
      let input_type = this.inputs.find((item) => { return item.name == "link" });
      if (field_name == "type" && $event.target.value == "youtube") {
        if (input_type) {
          this.inputs.find((item) => { return item.name == "link" }).readOnly = false;
        }
        let input_file = this.inputs.find((item) => { return item.type == "file" });
        if (input_file) {
          let index = this.inputs.indexOf(input_file);
          this.inputs.splice(index, 1);
        }
      }
      if (field_name == "type" && $event.target.value == "player") {
        if (input_type) {
          this.inputs.find((item) => { return item.name == "link" }).readOnly = true;
          this.inputs.push({
            "name": "upload_file",
            "type": "file",
            "label": "",
            "readOnly": false
          });
        }
      }

    }
  }

}
